import { useContext } from 'react';
import {
    useNavigate,
    useLocation,
    useParams,
    useSearchParams,
} from 'react-router-dom';
import RouterUtilsContext from './RouterUtilsContext';

export const withRouter = (Component) => {
    const Wrapper = (props) => {
        const navigate = useNavigate();
        const location = useLocation();
        const params = useParams();
        const [searchParams, setSearchParams] = useSearchParams();
        const routerUtilsContext = useContext(RouterUtilsContext);

        const navigateWithinParent = (path, ...rest) => {
            const { routePath } = routerUtilsContext;
            navigate((routePath ?? '') + path, ...rest);
        };

        return (
            <Component
                {...props}
                navigate={navigate}
                navigateWithinParent={navigateWithinParent}
                location={location}
                params={params}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
            />
        );
    };

    return Wrapper;
};

export default {};
